var render = function render(){var _vm=this,_c=_vm._self._c;return _c('insurance-table',{attrs:{"site-id":_vm.rowData.id,"cient-site-id":_vm.rowData.siteId,"read-only":_vm.readOnly,"site-name":_vm.rowData.siteName}})
}
var staticRenderFns = []

export { render, staticRenderFns }